<HomeNavBar/>
<div class="container py-5 scrollable-container mb-5">
  <!-- Heading -->
  <div class="text-center mb-5">
    <h2 class="fw-bold">Frequently asked questions</h2>
    <p class="text-muted">Stuck on something? We're here to help with all your questions and answers in one place.</p>
  </div>

  <!-- FAQ Grid -->
  <div class="row g-4 mb-5">
    <!-- Left Column -->
    <div class="col-md-6">
      <div class="mb-4">
        <h6 class="fw-bold"><i class="bi bi-question-circle me-2"></i>How can I quickly access the information or context I’m looking for?</h6>
        <p class="text-muted">You can use the search bar at the top of the page to find what you need. The search also provides recommendations to help you refine or recall what you’re looking for.</p>
      </div>

      <div class="mb-4">
        <h6 class="fw-bold"><i class="bi bi-question-circle me-2"></i>How do I filter content so that I only see the posts I’m interested in?</h6>
        <p class="text-muted">Use the dropdown menu to filter posts by the tags you want.</p>
      </div>

      <div class="mb-4">
        <h6 class="fw-bold"><i class="bi bi-question-circle me-2"></i>How can I navigate to my profile so that I can start building it?</h6>
        <p class="text-muted">Click on your profile icon at the top right corner of the page. From there, you can edit your details and begin building your profile.</p>
      </div>

      <div class="mb-4">
        <h6 class="fw-bold"><i class="bi bi-question-circle me-2"></i>Can everyone post on the platform?</h6>
        <p class="text-muted">Yes, all registered users can create and share posts. However, posts are first submitted to admins for review. Once approved, the posts will appear on the portal to ensure quality and relevance.</p>
      </div>

      <div class="mb-4">
        <h6 class="fw-bold"><i class="bi bi-question-circle me-2"></i>How can I move from the portal to access the rest of the system? Where can I see the menu?</h6>
        <p class="text-muted">Use the main navigation menu at the top of the page. This menu allows you to switch between the portal and other system features.</p>
      </div>

      <div class="mb-4">
        <h6 class="fw-bold"><i class="bi bi-question-circle me-2"></i>What’s the difference between an event inside a portal and an event on the event page?</h6>
        <p class="text-muted">Portal Events: Visible only to members of that specific portal.
Event Page Events: Visible to everyone, and anyone can RSVP.</p>
      </div>
    </div>

    <!-- Right Column -->
    <div class="col-md-6">
      <div class="mb-4">
        <h6 class="fw-bold"><i class="bi bi-question-circle me-2"></i>What makes the Publishing, Incident, and Engagement portals different?</h6>
        <p class="text-muted">Publishing Portal: For sharing articles and news. Incident Portal: For reporting incidents. Engagement Portal: For discussions and interaction among users</p>
      </div>

      <div class="mb-4">
        <h6 class="fw-bold"><i class="bi bi-question-circle me-2"></i>What is a portal?</h6>
        <p class="text-muted">A portal is a community group created for specific users. It can be used to store information, share posts, and allow group members to engage with each other.</p>
      </div>

      <div class="mb-4">
        <h6 class="fw-bold"><i class="bi bi-question-circle me-2"></i>Can I interact with other users?</h6>
        <p class="text-muted">Yes, you can interact with other users through posts, likes, comments, and shares.</p>
      </div>

      <div class="mb-4">
        <h6 class="fw-bold"><i class="bi bi-question-circle me-2"></i>Can I view other users’ profiles?</h6>
        <p class="text-muted">Yes, you can view other users’ profiles and see any information they have chosen to make public</p>
      </div>

      <div class="mb-4">
        <h6 class="fw-bold"><i class="bi bi-question-circle me-2"></i>When I leave a portal, how can I navigate back to it?</h6>
        <p class="text-muted">You can use the navigation menu or your portal list to return to the portal.</p>
      </div>

      <div class="mb-4">
        <h6 class="fw-bold"><i class="bi bi-question-circle me-2"></i>Who can add portal members to a portal?</h6>
        <p class="text-muted">Only platform admins and portal admins can add users to a portal.</p>
      </div>
    </div>
  </div>
</div>
